import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Pill, PackageCheck, ShieldCheck } from 'lucide-react';
const areas = [{
  title: 'Medical & Dental Devices',
  description: 'Precision components for diagnostic equipment, surgical instruments, dental aligners, surgical guides, and patient care devices. We understand the critical nature of these parts.',
  icon: Stethoscope,
  features: ['Tight tolerances', 'Biocompatible materials', 'Traceability']
}, {
  title: 'Dietary and Food Packaging',
  description: 'Specialized injection-molded packaging components for the supplement and food industry. We create caps, closures, droppers, and other precision-molded parts that protect product integrity.',
  icon: Pill,
  features: ['Tamper-evident designs', 'Child-resistant options', 'Brand-aligned aesthetics']
}, {
  title: 'Specialized Packaging',
  description: 'Custom caps and closures for pharmaceutical and healthcare applications. Functional, reliable, and compliant with industry standards.',
  icon: PackageCheck,
  features: ['High-cavity molds', 'Consistent threading', 'Leak-proof seals']
}];
export function Expertise() {
  return <section id="expertise" className="py-20 bg-neutral-50" data-id="element-166">
      <div className="container mx-auto px-4 md:px-6" data-id="element-167">
        <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-168">
          {/* Left Content */}
          <div className="w-full md:w-1/3 md:sticky md:top-24" data-id="element-169">
            <div className="inline-block p-3 rounded-2xl bg-blue-100 text-primary mb-6" data-id="element-170">
              <ShieldCheck className="h-8 w-8" data-id="element-171" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-172">
              Specialized Expertise Where It Matters Most
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-173">
              We don't try to be everything to everyone. We focus strictly on
              medical, dental, healthcare, and dietary/food packaging-related
              molding where precision and cleanliness are non-negotiable.
            </p>
            <div className="p-6 bg-primary rounded-xl text-white" data-id="element-174">
              <p className="font-medium text-lg mb-2" data-id="element-175">
                "Our focus allows us to go deeper into the specific needs of
                medical/dental and dietary/food manufacturers."
              </p>
              <p className="opacity-80 text-sm" data-id="element-176">
                — Founder, Plastic Engineering Solutions
              </p>
            </div>
          </div>

          {/* Right Grid */}
          <div className="w-full md:w-2/3 grid grid-cols-1 gap-6" data-id="element-177">
            {areas.map((area, index) => <motion.div key={area.title} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:border-blue-100 transition-colors" data-id="element-178">
                <div className="flex items-start gap-6" data-id="element-179">
                  <div className="p-3 bg-blue-50 rounded-lg text-primary shrink-0" data-id="element-180">
                    <area.icon className="h-6 w-6" data-id="element-181" />
                  </div>
                  <div data-id="element-182">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-183">
                      {area.title}
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-184">{area.description}</p>
                    <ul className="flex flex-wrap gap-3" data-id="element-185">
                      {area.features.map(feature => <li key={feature} className="text-sm font-medium text-gray-500 bg-gray-50 px-3 py-1 rounded-full" data-id="element-186">
                          {feature}
                        </li>)}
                    </ul>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}